export default {
  root: {
    borderRadius: 6
  }
}
